// slide
require("slick-carousel");
import AOS from "aos";
import "aos/dist/aos.css";
$(document).ready(function () {
    if ($("#modal-promocion").length) {
        $("#modal-promocion").modal("show");

        $("#cerrar-modal-promocion").click(function () {
            $("#modal-promocion").modal("hide");
        });
    }

    if ($("#atributos").length) {
        $("#atributos-slide").slick({
            dots: false,
            infinite: true,
            speed: 300,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $("#atributos .arrows"),
            prevArrow:
                '<a href="javascript:void(null);" class="arrow arrow-left"><img src="/images/proyecto-casa/flecha_izquierda.svg"/></a>',
            nextArrow:
                '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/proyecto-casa/flecha_derecha.svg"/></a>',
        });
    }

    if ($("#galeria").length) {
        $("#galeria-slide").slick({
            dots: false,
            infinite: true,
            speed: 300,
            autoplay: false,
            slidesToShow: 3,
            centerMode: true,
            centerPadding: "0",
            slidesToScroll: 1,
            appendArrows: $("#galeria .arrows"),
            appendDots: $("#galeria .dots"),
            prevArrow:
                '<a href="javascript:void(null);" class="arrow arrow-left"><img src="/images/proyecto-casa/flecha_izquierda_dark.svg"/></a>',
            nextArrow:
                '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/proyecto-casa/flecha_derecha_dark.svg"/></a>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
});
AOS.init();
